module.exports = __webpack_public_path__ + "img/name.187d55b4.svg";